import { Routes, Route } from 'react-router-dom';

import { List } from './components/List';
import { Edit } from './components/Edit';
import { Deleted } from './components/Deleted';

import { useUsers } from './Users.hooks';

export function UsersPage(): React.ReactElement {
  useUsers();

  return (
    <Routes>
      <Route index element={<List />} />

      <Route path=":id" element={<Edit />} />

      <Route path="new-user" element={<Edit />} />

      <Route path="deleted" element={<Deleted />} />
    </Routes>
  );
}
